import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from 'view/login/index';
import ForgotPassword from 'view/forgotPassword';
import NewPassword from 'view/forgotPassword/newPassword';
import Dashboard from 'view/dashboard/dashboard';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import PrivateRoute from 'components/privateRoute/PrivateRoute';
// import PreFormList from 'view/preForm';
import Form from 'view/allForms/form';
// import PostFormList from 'view/postForm';
// import PostForm from 'view/postForm/form';
import AllForms from 'view/allForms';
import UserManagement from 'view/userManagement';
import User from 'view/userManagement/user';
import newForm from 'view/allForms/form';
import Assignment from 'view/assignment/assignment';
import FormChecklist from 'view/formChecklist/FormChecklist'
// import StationWiseForms from 'view/formChecklist/StationWiseForms';
import FormList from 'view/formChecklist/FormList';
import StationForms from 'view/formChecklist/StationForms';
import DBPanelForm from 'view/formChecklist/formList/DBPanelForm';
import EarthingForm from 'view/formChecklist/formList/EarthingForm';
import HTCableForm from 'view/formChecklist/formList/HTCabelForm';
import LightningArresterForm from 'view/formChecklist/formList/LightningArresterForm';
import LTCableForm from 'view/formChecklist/formList/LTCabelForm';
import LTPanelForm from 'view/formChecklist/formList/LTPanelForm';
import APFCPanelForm from 'view/formChecklist/formList/APFCPanelForm';
import CableTrayForm from 'view/formChecklist/formList/CabelTrayForm';
import TransformerForm from 'view/formChecklist/formList/TransformerForm';
import VCBForm from 'view/formChecklist/formList/VCBForm';
import HOTOForm from 'view/formChecklist/formList/HOTOForm';

const App = () => {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/newpassword" element={<NewPassword />} />
          <Route path="/dashboard" element={<PrivateRoute title={'Dashboard'} roles={['admin', 'engineer']} component={Dashboard} />} />
          <Route path="/allforms" element={<PrivateRoute title={'Commissioning Forms'} roles={['admin', 'engineer']} component={AllForms} />} />
          <Route path="/allForms/form" element={<PrivateRoute title={'Commissioning Forms'} roles={['admin', 'engineer']} component={newForm} />} />
          <Route path="/usermanagement" element={<PrivateRoute title={'User Management'} roles={['admin']} component={UserManagement} />} />
          <Route path="/usermanagement/add" element={<PrivateRoute title={'Add User'} roles={['admin']} component={User} />} />
          <Route path="/usermanagement/edit/:userId" element={<PrivateRoute title={'Edit User'} roles={['admin']} component={User} />} />
          <Route path="/allForms/form/edit/:formId" element={<PrivateRoute title={'Edit Form'} roles={['admin', 'engineer']} component={Form} />} />
          <Route path="/allForms/form/view/:formId" element={<PrivateRoute title={'View Form'} roles={['admin', 'engineer']} component={Form} />} />
          <Route path="/allForms/form/review/:formId" element={<PrivateRoute title={'Review Form'} roles={['admin', 'engineer']} component={Form} />} />
          <Route path="/assignment" element={<PrivateRoute title={'Assignment'} roles={['admin']} component={Assignment} />} />

          {/* New Items */}

          <Route path="/formChecklist" element={<PrivateRoute title={'Create Forms'} roles={['admin', 'engineer']} component={FormChecklist} />} />
          <Route path="/formList" element={<PrivateRoute title={'Form List'} roles={['admin', 'engineer']} component={FormList} />} />
          <Route path="/formList/:stationId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={StationForms} />} />

          <Route path="/formList/:stationId/db_panel/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={DBPanelForm} />} />
          <Route path="/formList/:stationId/cabel_tray/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={CableTrayForm} />} />
          <Route path="/formList/:stationId/earthing/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={EarthingForm} />} />
          <Route path="/formList/:stationId/ht_cabel/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={HTCableForm} />} />
          <Route path="/formList/:stationId/lt_cabel/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={LTCableForm} />} />
          <Route path="/formList/:stationId/lt_panel/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={LTPanelForm} />} />
          <Route path="/formList/:stationId/apfc_panel/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={APFCPanelForm} />} />
          <Route path="/formList/:stationId/lightning_arrester/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={LightningArresterForm} />} />
          <Route path="/formList/:stationId/transformer/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={TransformerForm} />} />
          <Route path="/formList/:stationId/vcb/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={VCBForm} />} />
          <Route path="/formList/:stationId/hoto/:formId" element={<PrivateRoute title={'Station Forms'} roles={['admin', 'engineer']} component={HOTOForm} />} />

          <Route path="/formApproval" element={<PrivateRoute title={'Form Approval'} roles={['admin', 'engineer']} component={'DBPanelForm'} />} />
        </Routes>
        <ToastContainer position="top-right" theme="colored" />
        <Toaster />
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
